"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengePage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("@xyflow/react/dist/style.css");
var routes_1 = require("../../../../constants/routes");
var react_1 = require("@heroui/react");
var select_field_1 = require("../../../../components/form/select-field");
var date_field_1 = require("../../../../components/form/date-field");
var react_2 = require("@xyflow/react");
var challenge_1 = require("../../../../reducers/slices/challenge/challenge");
var IUser_1 = require("../../../../interfaces/IUser");
var permissions_1 = require("../../../../hooks/permissions");
var date_1 = require("@internationalized/date");
var date_fns_1 = require("date-fns");
var letsachieve_1 = require("../../../../api/letsachieve");
var main_1 = require("../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var box_1 = require("../../../../controls/box");
var challengeEditorContext_1 = require("../../../../contexts/challengeEditorContext");
var challenge_segment_1 = require("./challenge_segment");
var fileInputBox_1 = require("../../../../components/fileInputBox");
var challenge_editor_1 = __importDefault(require("./challenge_editor"));
var utils_1 = require("@doshexchnage/utils");
var react_3 = require("@iconify/react");
var label_1 = require("../../../../controls/label");
var constants_1 = require("./components/constants");
var read_only_banner_1 = require("../../../../components/readOnlyBanner/read_only_banner");
var pageHeader_1 = require("../../../../components/pageHeader");
var constants_2 = require("./constants");
var errors_1 = require("../../../../helpers/errors");
var console_1 = require("../../../../reducers/slices/console");
var upload_file_1 = require("../../../../api/calls/media/upload_file");
var react_4 = require("react");
var challenge_rewards_section_1 = require("./components/challenge_rewards_section");
var challenge_segments_section_1 = require("./components/challenge_segments_section");
// map Nodes and Edges (trees) into challenge objectives
var mapNodesToObjectives = function (nodes, edges) {
    var getNextNodes = function (current_node_id) {
        var nextEdges = edges.filter(function (edge) { return edge.source === current_node_id; });
        var nextNodes = nodes.filter(function (node) { return nextEdges.some(function (edge) { return edge.target === node.id; }); });
        return nextNodes.reduce(function (acc, node) {
            var nextNodes = getNextNodes(node.id);
            return __spreadArray(__spreadArray([], acc, true), nextNodes, true);
        }, nextNodes);
    };
    var objectivesNodes = nodes.filter(function (node) { return node.data.node_type === "objective"; });
    return objectivesNodes.map(function (objectiveNode) {
        var nextNodes = getNextNodes(objectiveNode.id);
        var rewardNodes = nextNodes.filter(function (node) { return node.data.node_type === "reward"; });
        var conditionNodes = nextNodes.filter(function (node) { return node.data.node_type === "condition"; });
        var nodeData = objectiveNode.data;
        return {
            _id: nodeData.config._id,
            title: nodeData.config.title,
            event_type: nodeData.config.event_type,
            scope: nodeData.config.scope,
            scopes: nodeData.config.scopes,
            trigger: nodeData.config.trigger,
            rewards: rewardNodes.map(function (rewardNode) {
                var rewardData = rewardNode.data;
                return rewardData.config;
            }),
            conditions: conditionNodes.map(function (conditionNode) {
                var conditionData = conditionNode.data;
                return conditionData.config;
            }),
        };
    });
};
// map objectives to Nodes and Edges (trees)
var mapObjectivesToFlows = function (objectives) {
    var _a, _b, _c, _d;
    var nodes = [];
    var edges = [];
    var _loop_1 = function (objective) {
        // Try to find exact match first, fallback to generic event_type_objective for custom events
        var nodeConfig = constants_1.NodeConfigurations.objective.find(function (node) { return node.data.config.event_type === objective.event_type; });
        if (!nodeConfig) {
            console.log("Using generic event_type_objective for custom event:", objective.event_type);
            nodeConfig = constants_1.NodeConfigurations.objective.find(function (node) { return node.type === "event_type_objective"; });
        }
        if (!nodeConfig) {
            console.error("nodeConfig not found and no fallback available for event_type:", objective.event_type);
            return "continue";
        }
        var objectiveNode = {
            id: objective._id,
            type: nodeConfig.type,
            position: { x: 0, y: 0 },
            data: __assign(__assign({}, nodeConfig.data), { config: __assign(__assign({}, nodeConfig.data.config), { _id: objective._id, event_type: objective.event_type, title: objective.title, scope: objective.scope, scopes: objective.scopes, trigger: objective.trigger }) }),
        };
        var rewardNodes = (_b = (_a = objective.rewards) === null || _a === void 0 ? void 0 : _a.map(function (reward) {
            var rewardNodeConfig = constants_1.NodeConfigurations.reward.find(function (node) { return node.data.config.type === reward.type; });
            if (!rewardNodeConfig) {
                console.log("rewardNodeConfig not found", reward.type);
                return null;
            }
            var id = "".concat(rewardNodeConfig.type, "-").concat(utils_1.Generate.randomAlphanumeric(8));
            var rewardNode = {
                id: id,
                type: rewardNodeConfig.type,
                position: { x: 0, y: 0 },
                data: __assign(__assign({}, rewardNodeConfig.data), { config: __assign(__assign({}, rewardNodeConfig.data.config), reward) }),
            };
            return rewardNode;
        }).filter(Boolean)) !== null && _b !== void 0 ? _b : [];
        var conditionNodes = (_d = (_c = objective.conditions) === null || _c === void 0 ? void 0 : _c.map(function (condition) {
            var conditionNodeConfig = constants_1.NodeConfigurations.condition.find(function (node) { return node.data.config.type === condition.type; });
            if (!conditionNodeConfig) {
                console.log("conditionNodeConfig not found", condition.type);
                return null;
            }
            var id = "".concat(condition.type, "-").concat(utils_1.Generate.randomAlphanumeric(8));
            var conditionNode = {
                id: id,
                type: conditionNodeConfig.type,
                position: { x: 0, y: 0 },
                data: __assign(__assign({}, conditionNodeConfig.data), { config: __assign(__assign({}, conditionNodeConfig.data.config), condition) }),
            };
            return conditionNode;
        }).filter(Boolean)) !== null && _d !== void 0 ? _d : [];
        nodes.push.apply(nodes, __spreadArray(__spreadArray([objectiveNode], conditionNodes, false), rewardNodes, false));
        console.log("nodes", nodes);
        var allEdges = nodes
            .map(function (node, index) {
            if (index === 0) {
                return null;
            }
            var previous = nodes[index - 1];
            return {
                id: "".concat(previous.id, "-").concat(node.id),
                source: previous.id,
                target: node.id,
            };
        })
            .filter(Boolean);
        edges.push.apply(edges, allEdges);
    };
    for (var _i = 0, objectives_1 = objectives; _i < objectives_1.length; _i++) {
        var objective = objectives_1[_i];
        _loop_1(objective);
    }
    return [nodes, edges];
};
var ChallengePage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var challenge_id = (0, react_router_dom_1.useParams)().challenge_id;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _j = (0, react_redux_1.useSelector)(function (state) { return state.challengeState; }), nodes = _j.nodes, edges = _j.edges, selectedChallenge = _j.selectedChallenge, isEdited = _j.isEdited, errors = _j.errors, file = _j.file, fileEdited = _j.fileEdited;
    var _k = (0, letsachieve_1.useGetChallengeQuery)(challenge_id !== null && challenge_id !== void 0 ? challenge_id : "", { skip: !challenge_id }), serverChallenge = _k.data, challengeFailed = _k.isError;
    var _l = (0, letsachieve_1.useSaveChallengeMutation)(), saveChallenge = _l[0], isSaving = _l[1].isLoading;
    var saveChallengeSegment = (0, letsachieve_1.useSaveChallengeSegmentMutation)()[0];
    var _m = (0, permissions_1.usePermission)(IUser_1.IPermissions.CHALLENGES), canCreate = _m.canCreate, canUpdate = _m.canUpdate;
    var isNew = !challenge_id;
    var canEdit = isNew ? canCreate : canUpdate;
    (0, react_4.useEffect)(function () {
        if (!challenge_id)
            dispatch((0, console_1.setPageTitle)("Create a challenge"));
        return function () {
            dispatch((0, challenge_1.clearState)());
        };
    }, []);
    (0, react_4.useEffect)(function () {
        if (challengeFailed)
            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CHALLENGES_ROUTE));
    }, [challengeFailed]);
    // the loaded challenge seeds the editable draft, and its objectives seed the flow graph
    (0, react_4.useEffect)(function () {
        var _a;
        if (!serverChallenge || isEdited)
            return;
        dispatch((0, challenge_1.setSelectedChallenge)(serverChallenge));
        var _b = mapObjectivesToFlows((_a = serverChallenge.objectives) !== null && _a !== void 0 ? _a : []), loadedNodes = _b[0], loadedEdges = _b[1];
        dispatch((0, challenge_1.setNodes)(loadedNodes));
        dispatch((0, challenge_1.setEdges)(loadedEdges));
    }, [serverChallenge, isEdited]);
    (0, react_4.useEffect)(function () {
        var _a;
        if (challenge_id) {
            dispatch((0, console_1.setPageTitle)("Challenge - ".concat((_a = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.title) !== null && _a !== void 0 ? _a : challenge_id)));
        }
        else if (!(selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge._id)) {
            // const itemID = generateXRID("m");
            // dispatch(setSelectedChallenge({ ...selectedChallenge, item_id: itemID }));
        }
    }, [selectedChallenge]);
    var onChange = function (challenge) {
        dispatch((0, challenge_1.setSelectedChallenge)(__assign(__assign({}, selectedChallenge), challenge)));
        if (!isEdited) {
            dispatch((0, challenge_1.setIsEdited)(true));
        }
    };
    var fileChange = function (file) {
        if (!fileEdited) {
            dispatch((0, challenge_1.setFileEdited)(true));
        }
        dispatch((0, challenge_1.setFile)(file));
        dispatch((0, challenge_1.setIsEdited)(true));
    };
    var validate = function (challenge) {
        var _a, _b;
        // let rewardValueError: string = "";
        // if (challenge?.rewards?.[0]?.type === "badges") {
        //   rewardValueError = "Badge is required";
        // } else if (challenge?.rewards?.[0]?.type === "currency") {
        //   rewardValueError = "Currency Value is required";
        // } else if (challenge?.rewards?.[0]?.type === "xp") {
        //   rewardValueError = "XP Points is required";
        // }
        var errors = {
            title: (challenge === null || challenge === void 0 ? void 0 : challenge.title) ? "" : "Title is required",
            // event_type: challenge?.event_type ? "" : "Event type is required",
            // trigger: {
            //   trigger_quantity: challenge?.trigger?.trigger_quantity ? "" : "Trigger quantity is required",
            // },
            // rewards: [
            //   {
            //     type: challenge?.rewards?.[0]?.type ? "" : "Reward type is required",
            //     value: challenge?.rewards?.[0]?.value ? "" : rewardValueError,
            //     currency_type: (() => {
            //       if (challenge?.rewards?.[0]?.type === "currency") {
            //         console.log(challenge?.rewards?.[0]?.currency_type);
            //         return challenge?.rewards?.[0]?.currency_type ? "" : "Currency type is required";
            //       }
            //     })(),
            //     currency: (() => {
            //       if (challenge?.rewards?.[0]?.type === "currency") {
            //         console.log(challenge?.rewards?.[0]?.currency_type);
            //         return challenge?.rewards?.[0]?.currency ? "" : "Currency is required";
            //       }
            //     })(),
            //   },
            // ],
            // scope: {},
            schedule: {
                start_date: ((_a = challenge === null || challenge === void 0 ? void 0 : challenge.schedule) === null || _a === void 0 ? void 0 : _a.start_date) ? "" : "Start date is required",
                end_date: ((_b = challenge === null || challenge === void 0 ? void 0 : challenge.schedule) === null || _b === void 0 ? void 0 : _b.end_date) ? "" : "End date is required",
            },
        };
        // if (challenge?.event_type && challenge?.event_type !== "numberOfLogins") {
        //   if (challenge?.scope?.type === "category") {
        //     errors.scope = { value: challenge?.scope?.value ? "" : "Category is required" };
        //   } else if (challenge?.scope?.type === "product") {
        //     errors.scope = { value: challenge?.scope?.value ? "" : "Product is required" };
        //   } else if (!challenge?.scope?.type) {
        //     errors.scope = { type: "Scope type is required" };
        //   }
        // }
        dispatch((0, challenge_1.setErrors)(errors));
        return (0, errors_1.generateErrorList)(errors);
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var objectives, challengePayload, errorList, response, saved, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    objectives = mapNodesToObjectives(nodes, edges);
                    challengePayload = __assign(__assign({}, selectedChallenge), { objectives: objectives, segments: undefined });
                    // Clean up temporary reward IDs before saving
                    if (challengePayload.rewards) {
                        challengePayload.rewards = challengePayload.rewards.map(function (reward) {
                            var _id = reward._id, rest = __rest(reward, ["_id"]);
                            // Only include _id if it's not a temporary ID
                            if (_id && !_id.startsWith("temp_")) {
                                return reward;
                            }
                            return rest;
                        });
                    }
                    errorList = validate(challengePayload);
                    if (errorList === null || errorList === void 0 ? void 0 : errorList.length) {
                        dispatch((0, main_1.setMessageModal)({ title: "Validation Error", messages: __spreadArray(["Please correct the following errors: ", ""], errorList, true) }));
                        return [2 /*return*/];
                    }
                    if (!(fileEdited && file)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, upload_file_1.upload_file)({
                            file: file,
                            type: "IMAGE",
                            file_name: file.name,
                            description: selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.description,
                            category: "challenge_image",
                        })];
                case 1:
                    response = _d.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.success) && (response === null || response === void 0 ? void 0 : response.content)) {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when uploading your icon!", messages: [response.message] }));
                        return [2 /*return*/];
                    }
                    challengePayload.image = __assign(__assign({}, challengePayload.image), { url: (_a = response === null || response === void 0 ? void 0 : response.content) === null || _a === void 0 ? void 0 : _a.location, etag: (_b = response === null || response === void 0 ? void 0 : response.content) === null || _b === void 0 ? void 0 : _b.etag, file_name: file.name });
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, saveChallenge(challengePayload).unwrap()];
                case 3:
                    saved = _d.sent();
                    dispatch((0, challenge_1.setSelectedChallenge)(saved));
                    dispatch((0, challenge_1.setIsEdited)(false));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _d.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Something went wrong when saving your challenge!",
                        messages: [(_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.error) !== null && _c !== void 0 ? _c : "The request was unsuccessful."],
                    }));
                    return [2 /*return*/];
                case 5:
                    // editing an existing challenge ends here; creating one offers to link a segment next
                    if (challenge_id && (selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge._id))
                        return [2 /*return*/];
                    if (saved === null || saved === void 0 ? void 0 : saved._id) {
                        navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CHALLENGES_ROUTE, "/").concat(saved._id));
                    }
                    dispatch((0, main_1.setContentModal)({
                        title: "Challenge creation confirmation",
                        content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col center justify-evenly text-center gap-8 py-2", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Your challenge has been added successfully.", textColor: "text-primary", size: "3xlarge" }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "You can proceed to linking your challenge to a segment.", textColor: "text-primary", size: "xlarge" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "md", variant: "secondary", onPress: function () {
                                                dispatch((0, main_1.setContentModal)(null));
                                            }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "md", variant: "primary", onPress: function () {
                                                dispatch((0, main_1.setContentModal)({
                                                    title: "Select Segment",
                                                    content: ((0, jsx_runtime_1.jsx)(challenge_segment_1.ChallengeSegment, { on_save: function (segment_id, run_for_current_members) { return __awaiter(void 0, void 0, void 0, function () {
                                                            var error_2;
                                                            var _a;
                                                            return __generator(this, function (_b) {
                                                                switch (_b.label) {
                                                                    case 0:
                                                                        if (!(saved === null || saved === void 0 ? void 0 : saved._id))
                                                                            return [2 /*return*/];
                                                                        _b.label = 1;
                                                                    case 1:
                                                                        _b.trys.push([1, 3, , 4]);
                                                                        return [4 /*yield*/, saveChallengeSegment({ challenge_id: saved._id, segment_id: segment_id, run_for_current_members: run_for_current_members }).unwrap()];
                                                                    case 2:
                                                                        _b.sent();
                                                                        dispatch((0, main_1.setMessageModal)({ title: "Success!", messages: ["Successfully saved the segment for this challenge."] }));
                                                                        return [3 /*break*/, 4];
                                                                    case 3:
                                                                        error_2 = _b.sent();
                                                                        dispatch((0, main_1.setMessageModal)({
                                                                            title: "Something went wrong when saving your challenge!",
                                                                            messages: [(_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.error) !== null && _a !== void 0 ? _a : "The request was unsuccessful."],
                                                                        }));
                                                                        return [3 /*break*/, 4];
                                                                    case 4:
                                                                        dispatch((0, main_1.setContentModal)(null));
                                                                        return [2 /*return*/];
                                                                }
                                                            });
                                                        }); } })),
                                                }));
                                            }, children: "Proceed" })] })] })),
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var newTime = (0, date_1.now)((0, date_1.getLocalTimeZone)());
    var startDate = ((_a = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule) === null || _a === void 0 ? void 0 : _a.start_date) && (0, date_1.fromDate)(new Date((_b = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule) === null || _b === void 0 ? void 0 : _b.start_date), (0, date_1.getLocalTimeZone)());
    var endDate = ((_c = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule) === null || _c === void 0 ? void 0 : _c.end_date) && (0, date_1.fromDate)(new Date((_d = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule) === null || _d === void 0 ? void 0 : _d.end_date), (0, date_1.getLocalTimeZone)());
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 h-full max-w-6xl mx-auto", children: [(0, jsx_runtime_1.jsx)(pageHeader_1.PageHeader, { back: { label: "Back to challenges", on_press: function () { return navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CHALLENGES_ROUTE)); } }, icon: isNew ? undefined : "solar:cup-star-linear", title: isNew ? "Create Challenge" : (serverChallenge === null || serverChallenge === void 0 ? void 0 : serverChallenge.title) || "Challenge", actions: canEdit ? ((0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", onPress: onSave, isPending: isSaving, isDisabled: !isEdited, variant: "primary", className: "".concat(isEdited ? "bg-secondary" : "bg-primary"), children: [(0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:content-save", width: 24 }), "Save"] })) : null }), !canEdit ? (0, jsx_runtime_1.jsx)(read_only_banner_1.ReadOnlyBanner, { feature: "challenges", className: "w-full" }) : null, (0, jsx_runtime_1.jsxs)(box_1.Box, { className: "flex flex-row border h-full w-full divide-x overflow-hidden", addPadding: false, children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col p-4 gap-3 md:max-w-80 3xl:max-w-sm h-full w-full rounded-l-lg overflow-y-auto", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Challenge Details", textColor: "text-primary", size: "large", bold: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3 pb-4", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { value: selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.title, onChange: function (value) { return onChange({ title: value }); }, isRequired: true, isReadOnly: !canEdit, isInvalid: !!(errors === null || errors === void 0 ? void 0 : errors.title), children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Challenge Title" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Christmas Shopper" }), (errors === null || errors === void 0 ? void 0 : errors.title) ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errors.title }) : null] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.description, onChange: function (value) { return onChange({ description: value }); }, isRequired: true, isReadOnly: !canEdit, isInvalid: !!(errors === null || errors === void 0 ? void 0 : errors.description), children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Description" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: " " }), (errors === null || errors === void 0 ? void 0 : errors.description) ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errors.description }) : null] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Image", textColor: "text-primary", bold: true }), (0, jsx_runtime_1.jsx)(fileInputBox_1.FileInputBoxControl, { previewFile: true, file: file, imageUrl: (_e = selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.image) === null || _e === void 0 ? void 0 : _e.url, onChange: fileChange, onClear: function () {
                                                    dispatch((0, challenge_1.setFile)(undefined));
                                                    dispatch((0, challenge_1.setFileEdited)(true));
                                                }, isReadOnly: !canEdit, required: true, colors: {
                                                    iconColor: "text-primary",
                                                    backgroundColor: "bg-white",
                                                    borderColor: "border-default border",
                                                    textColor: "text-inputText",
                                                }, supportedFileTypes: [".png", ".jpg", ".jpeg", ".svg"], maxFileSize: 10 * 1024 * 1024, errorText: errors === null || errors === void 0 ? void 0 : errors.image })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Schedule", textColor: "text-primary", bold: true }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(date_field_1.DatePickerField, { label: "Start", value: startDate || null, onChange: function (date) {
                                                            var start_date = (0, date_fns_1.startOfDay)(date.toDate((0, date_1.getLocalTimeZone)()));
                                                            onChange({ schedule: __assign(__assign({}, selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule), { start_date: start_date }) });
                                                        }, isRequired: true, isDisabled: !canEdit, errorMessage: (_f = errors === null || errors === void 0 ? void 0 : errors.schedule) === null || _f === void 0 ? void 0 : _f.start_date }), (0, jsx_runtime_1.jsx)(date_field_1.DatePickerField, { label: "End", value: endDate || null, onChange: function (date) {
                                                            var end_date = (0, date_fns_1.endOfDay)(date.toDate((0, date_1.getLocalTimeZone)()));
                                                            onChange({ schedule: __assign(__assign({}, selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.schedule), { end_date: end_date }) });
                                                        }, isRequired: true, isDisabled: !canEdit, errorMessage: (_g = errors === null || errors === void 0 ? void 0 : errors.schedule) === null || _g === void 0 ? void 0 : _g.end_date })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: "Configure", textColor: "text-primary", bold: true }), (0, jsx_runtime_1.jsx)(select_field_1.SelectField, { label: "Status", placeholder: "Select status", value: selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.status, items: constants_2.challengeStatusOptions.map(function (option) { return ({ label: option.label, value: option.key }); }), onChange: function (value) {
                                                    onChange({ status: value });
                                                }, isDisabled: !canEdit, errorMessage: errors === null || errors === void 0 ? void 0 : errors.status }), (0, jsx_runtime_1.jsxs)(react_1.Checkbox, { isSelected: selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.visible, onChange: function (isSelected) {
                                                    onChange({ visible: isSelected });
                                                }, isDisabled: !canEdit, children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, {}) }), (0, jsx_runtime_1.jsx)(react_1.Checkbox.Content, { children: (0, jsx_runtime_1.jsx)(react_1.Label, { children: "Visible to users" }) })] })] }), (0, jsx_runtime_1.jsx)(challenge_rewards_section_1.ChallengeRewardsSection, { rewards: (selectedChallenge === null || selectedChallenge === void 0 ? void 0 : selectedChallenge.rewards) || [], onChange: function (rewards) { return onChange({ rewards: rewards }); }, isReadOnly: !canEdit }), challenge_id ? (0, jsx_runtime_1.jsx)(challenge_segments_section_1.ChallengeSegmentsSection, { challenge_id: challenge_id, segments: (_h = serverChallenge === null || serverChallenge === void 0 ? void 0 : serverChallenge.segments) !== null && _h !== void 0 ? _h : [], is_read_only: !canEdit }) : null] })] }), (0, jsx_runtime_1.jsx)(challengeEditorContext_1.ChallengeEditorProvider, { isReadOnly: !canEdit, children: (0, jsx_runtime_1.jsx)(react_2.ReactFlowProvider, { children: (0, jsx_runtime_1.jsx)(challenge_editor_1.default, { className: "rounded-r-lg " }) }) })] })] }));
};
exports.ChallengePage = ChallengePage;
